import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const ContentTypeForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [contentTypeName, setContentTypeName] = useState("");
  const [loading, setLoading] = useState(false);
  const [originalContentTypeName, setOriginalContentTypeName] = useState("");


  useEffect(() => {
    if (id) {
      setLoading(true);
      supabase
        .from("contentType")
        .select("contentType")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            // alert("Failed to load content type");
            Swal.fire({
              position: "top-end", // top-right corner
              icon: "error", // success, error, warning, info
              title: "Failed to load content type", // your message
              showConfirmButton: false, // no OK button
              timer: 3000, // auto close after 3 seconds
              timerProgressBar: true, // shows a progress bar
              toast: true, // makes it a toast
              background: "white", // optional, Tailwind prefers light bg
              customClass: {
                popup: "shadow-lg rounded-md p-3", // Tailwind classes
              },
            });
            navigate("/content-type");
          } else {
            // setContentTypeName(data.contentType);
            setContentTypeName(data.contentType);
            setOriginalContentTypeName(data.contentType.trim().toLowerCase());

          }
          setLoading(false);
        });
    }
  }, [id, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (!contentTypeName.trim()) {
      // alert("Please enter a content type name");
      Swal.fire({
        position: "top-end", // top-right corner
        icon: "warning", // success, error, warning, info
        title: "Please enter a content type name", // your message
        showConfirmButton: false, // no OK button
        timer: 3000, // auto close after 3 seconds
        timerProgressBar: true, // shows a progress bar
        toast: true, // makes it a toast
        background: "white", // optional, Tailwind prefers light bg
        customClass: {
          popup: "shadow-lg rounded-md p-3", // Tailwind classes
        },
      });
      return;
    }

    setLoading(true);

    const normalized = contentTypeName.trim().toLowerCase();

    // ✅ ADD MODE — strict duplicate check
    if (!id) {
      const { data: existing } = await supabase
        .from("contentType")
        .select("id")
        .eq("contentType", contentTypeName.trim());

      if (existing && existing.length > 0) {
        setLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `"${contentTypeName}" already exists`,
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          background: "white",
        });
        return;
      }
    }

    // ✅ EDIT MODE — only check if name changed
    if (id) {
      if (normalized !== originalContentTypeName) {
        const { data: existing } = await supabase
          .from("contentType")
          .select("id")
          .eq("contentType", contentTypeName.trim())
          .neq("id", id); // 🔑 exclude self

        if (existing && existing.length > 0) {
          setLoading(false);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `"${contentTypeName}" already exists`,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
            background: "white",
          });
          return;
        }
      }
    }


    if (id) {
      // Update existing content type
      const { error } = await supabase
        .from("contentType")
        .update({ contentType: contentTypeName.trim() })
        .eq("id", id);
      setLoading(false);

      if (error) {
        // alert("Failed to update content type");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "error", // success, error, warning, info
          title: "Failed to update content type", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        // alert("Content type updated successfully");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Content type updated successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
        navigate("/content-type");
      }
    } else {
      // Insert new content type
      const { error } = await supabase
        .from("contentType")
        .insert([{ contentType: contentTypeName.trim() }]);
      setLoading(false);

      if (error) {
        // alert("Failed to add content type");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "error", // success, error, warning, info
          title: "Failed to add content type", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        // alert("Content type added successfully");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Content type added successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
        navigate("/content-type");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => navigate(-1)}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border border-gray-300 rounded-md p-8 shadow-md"
        >
          <h1 className="text-3xl font-bold text-center text-gray-800">
            {id ? "Edit Content Type" : "Add Content Type"}
          </h1>

          <div>
            <label
              htmlFor="contentTypeName"
              className="block mb-2 font-semibold text-gray-700"
            >
              Enter content type name
            </label>
            <input
              id="contentTypeName"
              name="contentTypeName"
              type="text"
              value={contentTypeName}
              onChange={(e) => setContentTypeName(e.target.value)}
              placeholder="Enter content type name"
              autoFocus
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            />
          </div>

          <div className="flex justify-center gap-4">
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold text-lg"
            >
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate("/content-type")}
              className="px-8 py-3 font-semibold text-lg"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContentTypeForm;
